import { useEffect, useState } from 'react';
import CookieConsent from 'react-cookie-consent';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { hasMadeChoice, grantConsent, revokeConsent, CONSENT_CHANGED_EVENT } from '../../utils/cookieConsent';

// Analytics consent, asked once on every page until the visitor chooses (Account › Privacy changes it later)
export const CookieBanner = () => {
  const { t } = useTranslation();
  const [isHidden, setIsHidden] = useState(hasMadeChoice());

  useEffect(() => {
    // Accepting or declining anywhere (here or in Account) answers the notice
    const handler = () => setIsHidden(hasMadeChoice());
    window.addEventListener(CONSENT_CHANGED_EVENT, handler);
    return () => window.removeEventListener(CONSENT_CHANGED_EVENT, handler);
  }, []);

  return (
    <CookieConsent
      disableStyles
      location="bottom"
      visible={isHidden ? 'hidden' : 'show'}
      containerClasses="mt-root mt-cookies"
      // An open modal (login, signup…) closes on any click outside it; react-aria leaves out "top layer" elements, so
      // answering the notice keeps the modal open, and the modal doesn't hide the notice from screen readers
      customContainerAttributes={{ 'data-react-aria-top-layer': true }}
      contentClasses="mt-cookies__text"
      buttonWrapperClasses="mt-cookies__actions"
      buttonClasses="mt-btn mt-btn--primary"
      declineButtonClasses="mt-btn mt-btn--quiet"
      cookieName="acceptCookies"
      buttonText={t('standalone.cookiesButton')}
      enableDeclineButton
      flipButtons
      declineButtonText={t('standalone.cookiesDecline')}
      expires={150}
      ariaAcceptLabel={t('standalone.cookiesButton')}
      ariaDeclineLabel={t('standalone.cookiesDecline')}
      onAccept={grantConsent}
      onDecline={() => {
        revokeConsent();
        setIsHidden(true);
      }}
    >
      {t('standalone.cookies')} {t('standalone.cookiesMore')}{' '}
      {/* `!`: .mt-root a drops underlines, and this link must read as one */}
      <Link className="!underline underline-offset-2" to="/privacy">
        {t('standalone.privacyLinkText')}
      </Link>
      .
    </CookieConsent>
  );
};
